import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton
} from '@mui/material';
import {
  AutoAwesome as AutoAwesomeIcon,
  Campaign as CampaignIcon,
  CropFree as CropIcon
} from '@mui/icons-material';

const Navigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const isActive = (path) => location.pathname === path;
  
  return (
    <AppBar 
      position="static" 
      sx={{ 
        background: 'transparent',
        boxShadow: 'none',
        borderBottom: '1px solid rgba(99, 102, 241, 0.2)',
        mb: 4
      }}
    >
      <Toolbar>
        <Box sx={{ display: 'flex', alignItems: 'center', mr: 4 }}>
          <IconButton 
            edge="start" 
            color="inherit" 
            aria-label="logo"
            onClick={() => navigate('/')}
          >
            <AutoAwesomeIcon sx={{ fontSize: 32, color: 'primary.main' }} />
          </IconButton>
          <Typography
            variant="h6"
            sx={{
              ml: 1,
              fontWeight: 700,
              background: 'linear-gradient(135deg, #6366F1, #8B5CF6)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              color: 'transparent'
            }}
          >
            AI Suite
          </Typography>
        </Box>
        
        <Box sx={{ flexGrow: 1, display: 'flex', gap: 2 }}>
          <Button
            startIcon={<CropIcon />}
            onClick={() => navigate('/')}
            sx={{
              color: isActive('/') ? 'primary.main' : 'text.secondary',
              borderBottom: isActive('/') ? '2px solid' : 'none',
              borderColor: 'primary.main',
              borderRadius: 0,
              pb: 1,
              '&:hover': {
                bgcolor: 'rgba(99, 102, 241, 0.1)'
              }
            }}
          >
            Assets
          </Button>
          
          <Button
            startIcon={<CampaignIcon />}
            onClick={() => navigate('/campaigns')}
            sx={{
              color: isActive('/campaigns') ? 'primary.main' : 'text.secondary',
              borderBottom: isActive('/campaigns') ? '2px solid' : 'none',
              borderColor: 'primary.main',
              borderRadius: 0,
              pb: 1,
              '&:hover': {
                bgcolor: 'rgba(99, 102, 241, 0.1)'
              }
            }}
          >
            Campaigns
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navigation;